import { z } from 'zod';
import { ViewPropertySchema } from '../view/viewSchema';

export const PluginSchema = z.object({
    id: z.string(),
    name: z.string(),
    traits: z.array(ViewPropertySchema),
});

export const PluginListResponseSchema = z.object({
    data: z.array(PluginSchema),
});
